<template>
  <div>
    <div class="top-image">
      <div class="top-message">No Development, No Life.</div>
    </div>
    <app-content>
      <div>
        このサイトはプログラマ 臼居 和真のポートフォリオです。<br />
        本サイトでは、今までに開発した作品等を掲載しています。
      </div>
      <div class="about-link">
        <leading-link to="/about" size="32">About</leading-link>
      </div>
    </app-content>
  </div>
</template>

<script>
import AppContent from 'src/components/AppContent'
import LeadingLink from 'src/components/LeadingLink'

export default {
  components: {
    AppContent,
    LeadingLink
  }
}
</script>

<style>
.top-image {
  width: 100%;
  height: calc(100vh - 88px);
  background-color: white;
  background-image: url('/assets/Home/office-1734485_1920.jpg');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.top-message {
  padding-top: 128px;
  text-align: center;
  font-family: cursive;
  font-size: 48px;
}

.about-link {
  display: flex;
  margin-top: 64px;
  margin-bottom: 64px;
  justify-content: center;
}

@media screen and (max-width: 480px) {
  .top-image {
    height: calc(100vh - 72px);
  }

  .top-message {
    font-size: 28px;
  }
}
</style>
